import  * as actions from '../actions/actionTypes'
import { IStatsOverallState, IState } from '../store/state';
import { IMatchDetailsExtendedData } from '../types/IMatchDetailsExtendedFeed';

const initialState : IStatsOverallState = {}

const statsOverall = (state:IStatsOverallState = initialState, action:any) : IStatsOverallState => {
	switch (action.type) {
		// fetch information from feed and move it into the store
		case actions.FETCH_MATCH_DETAILS_EXTENDED_SUCCEEDED:
			if(action.data.doc && action.data.doc[0]) {
				const data = action.data.doc[0].data as IMatchDetailsExtendedData;
				return Object.assign({}, state, { [data._matchid]: data } );
			}
			else {
				return state;
			}
		case actions.MATCH_PURGE:
			const { matchId } = (action as any).id;
			return Object.assign({}, ...Object.keys(state).filter( key => matchId != key ).map( key => state[key as any] ));
		default:
			return state
	}
}

// getter method to fetch only information of interest (statistic data)
export const getStatsOverallForMatchId = (state:IState,matchId:number) => {
	// only send if data exists
	if(state.statsOverall[matchId] && state.statsOverall[matchId].values) {

		// we need to add this information to the values property to have it in statsOverall container
		let home = state.statsOverall[matchId].home_points_won.value;
		let away = state.statsOverall[matchId].home_points_won.count - home;
		// FIXME this getter modifies the state *fp*
		state.statsOverall[matchId].values.last10Points = { name:'', value: {home: home, away: away} };
		return state.statsOverall[matchId].values;
	}
	else {
		return null;
	}
}

export default statsOverall
